(function () {
  const l = {
    checkbox: '.juo-subscribe-cart__selling-plans-checkbox',
    select: '.juo-subscribe-cart__selling-plan-switcher--select',
  };
  async function a() {
    document.addEventListener('click', async function (s) {
      var e;
      if ((e = s.target) != null && e.matches(l.checkbox)) {
        const t = s.target;
        if (t.checked) {
          const c = t.dataset.variantId,
            n = document.querySelector(`select[data-variant-id="${c}"]`);
          await u(
            t.dataset.variantId,
            n.value,
            t.closest('.juo-subscribe-switcher')
          );
        } else
          await y(t.dataset.variantId, t.closest('.juo-subscribe-switcher'));
      }
    }),
      document.addEventListener('change', async function (s) {
        var e;
        if ((e = s.target) != null && e.matches(l.select)) {
          const t = s.target;
          await u(
            t.dataset.variantId,
            t.value,
            t.closest('.juo-subscribe-switcher')
          );
        }
      });
  }
  function u(s, e, t) {
    var n;
    if (e == null) return;
    t == null || t.classList.add('loading'),
      (n = t == null ? void 0 : t.querySelector('.pill-loader')) == null ||
        n.setAttribute('aria-busy', 'true');
    const c = window.Shopify.routes.root ?? '/';
    fetch(c + 'cart.js')
      .then((i) => i.json())
      .then(async function (i) {
        for (const o of i.items)
          String(o.variant_id) === s &&
            (await fetch(c + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
                id: o.key,
                quantity: o.quantity,
                selling_plan: e,
                properties: {
                  ...o.properties,
                  _juo_subscribe_cart: e,
                  _juo_source: 'subscribe-cart',
                },
              }),
            }));
      })
      .finally(() => {
        var i, o;
        t == null || t.classList.remove('loading'),
          (i = t == null ? void 0 : t.querySelector(l.select)) == null ||
            i.classList.remove('hidden'),
          (o = t == null ? void 0 : t.querySelector('.pill-loader')) == null ||
            o.removeAttribute('aria-busy');
        document.dispatchEvent(new Event('reload-side-cart')); 
      });
  }
  function y(s, e) {
    var c;
    if (s == null) return;
    e == null || e.classList.add('loading'),
      (c = e == null ? void 0 : e.querySelector('.pill-loader')) == null ||
        c.setAttribute('aria-busy', 'true');
    const t = window.Shopify.routes.root ?? '/';
    fetch(t + 'cart.js')
      .then((n) => n.json())
      .then(async function (n) {
        for (const i of n.items)
          String(i.variant_id) === s &&
            (await fetch(t + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
                id: i.key,
                quantity: i.quantity,
                selling_plan: null,
                properties: { ...i.properties, _juo_subscribe_cart: null },
              }),
            }));
      })
      .finally(() => {
        var n, i;
        e == null || e.classList.remove('loading'),
          (n = e == null ? void 0 : e.querySelector(l.select)) == null ||
            n.classList.add('hidden'),
          (i = e == null ? void 0 : e.querySelector('.pill-loader')) == null ||
            i.removeAttribute('aria-busy');
      document.dispatchEvent(new Event('reload-side-cart'));
      });
  }
  function d() {
    window.Shopify != null &&
      (document.readyState === 'complete' ||
      document.readyState === 'interactive'
        ? a()
        : document.addEventListener('DOMContentLoaded', a));
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', d)
    : d();
})();
